<template>
  <span>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Job Title</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.job_title"
            class="form-control"
            autocomplete="off"
            placeholder="Job Title"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Job Done By</label>
        <div class="col-sm-12">
          <my-select
            disableFormControl="true"
            :selection.sync="form.job_done_by_id"
            :suggestions="JobDoneBy"
            placeholder="Select Job Done By"
          ></my-select>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Expected Completion Date</label>
        <div class="col-sm-12">
          <my-datepicker
            :date.sync="form.expected_completion_date"
            placeholder="Enter Expected Completion Date"
          ></my-datepicker>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Completed Date</label>
        <div class="col-sm-12">
          <my-datepicker
            :date.sync="form.completed_date"
            placeholder="Enter Completed Date"
          ></my-datepicker>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Job Status</label>
        <div class="col-sm-12">
          <my-select
            disableFormControl="true"
            :selection.sync="form.job_status"
            :suggestions="jobStatuses"
            placeholder="Select Job Status"
          ></my-select>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Attachment</label>
        <div class="col-sm-12">
          <input
            type="file"
            id="file"
            name="file"
            ref="file"
            accept="application/ms-excel"
            @input="attachmentAdded"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label">Job Done Comments</label>
        <div class="col-sm-12">
          <textarea
            name="job_done_comments"
            class="form-control"
            id=""
            cols="5"
            rows="5"
            v-model="form.job_done_comments"
          ></textarea>
        </div>
      </div>

      <div class="col-md-6">
        <label class="col-form-label">Job Description</label>
        <div class="col-sm-12">
          <textarea
            name="job_description"
            class="form-control"
            id=""
            cols="5"
            rows="5"
            v-model="form.job_description"
          ></textarea>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "OrganizationFormWidget",
  props: ["form"],
  data() {
    return {
      JobDoneBy: [],
      jobStatuses: [
        { id: "Pending", name: "Pending" },
        { id: "Completed", name: "Completed" },
      ],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("office_job_schedulers/masters");
      masters = masters.data;
      masters.job_done_by.forEach((user) => {
        this.JobDoneBy.push({
          id: user.id,
          name: user.first_name,
        });
      });
    },
    attachmentAdded() {
      let attachment = this.$refs.file.files[0];
      this.$emit("attachmentAdded", attachment);
    },
  },
};
</script>
